import React, { useState, useEffect } from "react";
import {
  Grid,
  Divider,
  Button,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MuiLink from "@material-ui/core/Link";
import { useSelector } from "react-redux";
import PremiseDetails from "./view/e_connection-address";
import MailingAddress from "./view/e_communication-address";
import { ticketService } from "../model/_service";

const useStyles = makeStyles((theme) => ({
  textFieldsContainer: {
    minHeight: "57vh",
    padding: "2%"
  },
  containers: {
    padding: "0 2%"
  },
  cancel: {
    color: theme.palette.ePrimary.base,
  },
  buttonGrid: {
    textAlign: "right",
    margin: "0.4rem 0",
  },
  dividerStyle: {
    width: "100%",
    margin: "1.5rem 0",
    textAlign: "center",
    backgroundColor: theme.palette.eLight.base,
  },
  nextButton: {
    padding: "3% 30%",
    marginLeft: "1rem",
    marginRight: "3rem",
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
  },
  cancelNextAlign: {
    justifyContent: "right",
    align: "right",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  }
}));

export default function E_PremiseDetails(props) {
  const { divisionList, setdivisionList,
    districtPremise, address1Premise, address2Premise, postOfficePremise, divisionPremise, divisionCodePremise, postCodePremise, thanaPremise,
    setDistrictPremise, setAddress1Premise, setAddress2Premise, setPostOfficePremise, setDivisionPremise, setDivisionCodePremise, setPostCodePremise, setThanaPremise,
    districtMailing, address1Mailing, address2Mailing, postOfficeMailing, divisionMailing, postCodeMailing, thanaMailing,
    setDistrictMailing, setAddress1Mailing, setAddress2Mailing, setPostOfficeMailing, setDivisionMailing, setDivisionCodeMailing, setPostCodeMailing, setThanaMailing,
    sameAsPremiseCheck, setSameAsPremiseCheck, setActiveStep, handleClickOpen, checkBoxEnable, connectionOnExistingPremise, setconnectionOnExistingPremise,
    premiseType, setpremiseType, premiseCategory, setpremiseCategory, showConnectionOnExistingPremise,
    setpremiseTypeCode,
    setpremiseCategoryCode,existingPremisesList,
    setexistingPremiseID,
    existingPremiseValue,
    setexistingPremiseValue,
    sndValue,setSndValue,
    sndCode,setSndCode,districtdropdown, setdistrictdropdown,thanadropdown, setthanadropdown,existingCustomer,
    masterDataAddress1Mailing,masterDataAddress2Mailing,masterDataPostOfficeMailing,masterDataPostCodeMailing,masterDataDistrictMailing,
    masterDataDivisionCodeMailing,
    masterDataDivisionMailing,
    masterDataThanaMailing,
  } = props;
  const classes = useStyles();
  const [isNextEnable, setIsNextEnable] = useState(false);
  const [isCheckLocal, setIsCheckLocal] = useState(false);
  const labels = useSelector((store) => store?.labels?.data?.getLabels?.E_PREMISE_DETAILS);
  const zipLength = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_LENGTH);
  const zipLengthError = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_MIN_LENGTH);
  const languageCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  useEffect(() => {
    if (languageCode) {
      ticketService
        .getDropdownpData("E_DIVISION_LIST", languageCode)
        .then((res) => {
          setdivisionList(res?.data?.data?.getDropdownData);
        })
        .catch(() => {
          setdivisionList(null);
        });
    }
  }, [languageCode]);

  const checkBoxHandler = (event) => {
    if (event.target.checked) {
      setSameAsPremiseCheck(true);
      setMailing();
    } else {
      setSameAsPremiseCheck(false);
      resetMailing();
    }
  };
  useEffect(() => {
    if(existingCustomer=="yes"){
       if( checkBoxEnable   && masterDataAddress1Mailing && masterDataDistrictMailing  && masterDataDivisionMailing && masterDataPostCodeMailing && 
        masterDataPostCodeMailing.length >= parseInt(zipLengthError) && address1Premise && districtPremise  && divisionPremise && postCodePremise && postCodePremise.length >= parseInt(zipLengthError)) {
        setIsNextEnable(true)}
        else if(existingPremiseValue    && masterDataAddress1Mailing && masterDataDistrictMailing  && masterDataDivisionMailing && masterDataPostCodeMailing && 
          masterDataPostCodeMailing.length >= parseInt(zipLengthError)){
          setIsNextEnable(true);
        }else{
          setIsNextEnable(false);
        }
                
    }
    else{
      if (checkBoxEnable  && address1Mailing && districtMailing  && divisionMailing && postCodeMailing && postCodeMailing.length >= parseInt(zipLengthError)) {
        setIsNextEnable(true);}
        else{
        setIsNextEnable(false);
        }
    }
  }, [checkBoxEnable, existingCustomer,districtMailing, address1Mailing, divisionMailing, postCodeMailing,districtMailing,masterDataAddress1Mailing,masterDataDistrictMailing,masterDataDivisionMailing,masterDataPostCodeMailing,existingPremiseValue])
  const setMailing = () => {
    setDistrictMailing(districtPremise);
    setAddress1Mailing(address1Premise);
    setAddress2Mailing(address2Premise);
    setPostOfficeMailing(postOfficePremise);
    setDivisionMailing(divisionPremise);
    setDivisionCodeMailing(divisionCodePremise);
    setPostCodeMailing(postCodePremise);
    setThanaMailing(thanaPremise)
  }
  const resetMailing = () => {
    setDistrictMailing("");
    setAddress1Mailing("");
    setAddress2Mailing("");
    setPostOfficeMailing("");
    setDivisionMailing("");
    setDivisionCodeMailing("");
    setPostCodeMailing("");
    setThanaMailing("");
  }

  const nextHandler = () => {
    setActiveStep(2);
  };

  return (
    <>
      <Grid container spacing={5} className={classes.textFieldsContainer}>
        <Grid item xs={12} md={12} lg={6}>
          <PremiseDetails
          districtdropdown={districtdropdown}
          setdistrictdropdown={setdistrictdropdown}
          thanadropdown={thanadropdown}
           setthanadropdown={setthanadropdown}
            divisionList={divisionList}
            districtPremise={districtPremise}
            address1Premise={address1Premise}
            address2Premise={address2Premise}
            postOfficePremise={postOfficePremise}
            divisionPremise={divisionPremise}
            setDivisionCodePremise={setDivisionCodePremise}
            postCodePremise={postCodePremise}
            thanaPremise={thanaPremise}
            setThanaPremise={setThanaPremise}
            setDistrictPremise={setDistrictPremise}
            setAddress1Premise={setAddress1Premise}
            setAddress2Premise={setAddress2Premise}
            setPostOfficePremise={setPostOfficePremise}
            setDivisionPremise={setDivisionPremise}
            setPostCodePremise={setPostCodePremise}
            sameAsPremiseCheck={sameAsPremiseCheck}
            setSameAsPremiseCheck={setSameAsPremiseCheck}
            connectionOnExistingPremise={connectionOnExistingPremise}
            setconnectionOnExistingPremise={setconnectionOnExistingPremise}
            premiseType={premiseType}
            setpremiseType={setpremiseType}
            premiseCategory={premiseCategory}
            setpremiseCategory={setpremiseCategory}
            showConnectionOnExistingPremise={showConnectionOnExistingPremise}
            setpremiseTypeCode={setpremiseTypeCode}
            setpremiseCategoryCode={setpremiseCategoryCode}
            existingPremisesList={existingPremisesList}
            setexistingPremiseID={setexistingPremiseID}
            existingPremiseValue={existingPremiseValue}
            setexistingPremiseValue={setexistingPremiseValue}
            sndCode={sndCode}
            setSndCode={setSndCode}
            sndValue={sndValue}
            setSndValue={setSndValue}
          ></PremiseDetails>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <MailingAddress
          districtdropdown={districtdropdown}
          setdistrictdropdown={setdistrictdropdown}
          thanadropdown={thanadropdown}
           setthanadropdown={setthanadropdown}
            divisionList={divisionList}
            districtMailing={districtMailing}
            address1Mailing={address1Mailing}
            address2Mailing={address2Mailing}
            postOfficeMailing={postOfficeMailing}
            divisionMailing={divisionMailing}
            setDivisionCodeMailing={setDivisionCodeMailing}
            postCodeMailing={postCodeMailing}
            thanaMailing={thanaMailing}
            setDistrictMailing={setDistrictMailing}
            setAddress1Mailing={setAddress1Mailing}
            setAddress2Mailing={setAddress2Mailing}
            setPostOfficeMailing={setPostOfficeMailing}
            setDivisionMailing={setDivisionMailing}
            setPostCodeMailing={setPostCodeMailing}
            sameAsPremiseCheck={sameAsPremiseCheck}
            setSameAsPremiseCheck={setSameAsPremiseCheck}
            setThanaMailing={setThanaMailing}
            checkBoxHandler={checkBoxHandler}
            checkBoxEnable={checkBoxEnable}
            existingCustomer={existingCustomer}
            masterDataAddress1Mailing={masterDataAddress1Mailing}
            masterDataAddress2Mailing={masterDataAddress2Mailing}
            masterDataPostOfficeMailing={masterDataPostOfficeMailing}
            masterDataPostCodeMailing={masterDataPostCodeMailing}
            masterDataDistrictMailing={masterDataDistrictMailing}
            masterDataDivisionCodeMailing={masterDataDivisionCodeMailing}
            masterDataDivisionMailing={masterDataDivisionMailing}
            masterDataThanaMailing={masterDataThanaMailing}
            props={props}
          ></MailingAddress>
        </Grid>
      </Grid>
      <Grid item xs={12} className={[classes.containers, classes.gridContentAlign, classes.lastHR]}>
        <Divider className={classes.dividerStyle}></Divider>
      </Grid>
      <Grid container spacing={0} alignItems="center" justify="flex-end" className={[classes.containers, classes.cancelNextAlign]}>
        <Grid item>
          <MuiLink
            component="button"
            onClick={() => {
              handleClickOpen();
            }}
            underline="hover"
            className={classes.cancel}
          >
            <Typography variant="subtitle2">
              <b>{labels?.E_PREMISE_DETAILS_CANCEL}</b>
            </Typography>
          </MuiLink>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            className={classes.nextButton}
            onClick={nextHandler}
            disabled={!isNextEnable}
          >
            {labels?.E_PREMISE_DETAILS_NEXT}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}